import React from "react";
import styled from "styled-components";
import { useOutletContext } from "react-router-dom";
import { Session } from "@supabase/supabase-js";

import AddLinkForm from "../../forms/AddLinkForm";
import Heading, { HeadingVariants } from "../../components/atoms/Heading";

const AddLinkPage = () => {
  const [session] = useOutletContext<Session[]>();

  return (
    <StyledAddLinkPage>
      <Heading variant={HeadingVariants.H1}>Add new link</Heading>

      <AddLinkForm
        userId={session?.user?.id || ""}
        currentPoints={session?.user.user_metadata?.points}
        username={session?.user.user_metadata?.username}
      />
    </StyledAddLinkPage>
  );
};

const StyledAddLinkPage = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

export default AddLinkPage;
